<template>
  <v-row>
    <v-col cols="12" v-if="$store.state.bulks.retrieveLoader">
      <v-boilerplate type="table-heading, list-item-two-line" />
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="table" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <router-link class="subtitle-1 routerLink font-weight-medium" :to="{name: 'InvoiceBulkListCreate'}">Facturación masiva</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>
            <code class="body-2 text--secondary">{{instance.id}}</code>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn v-if="instance.file" class="mr-2" :href="instance.file" target="_blank" outlined color="secondary" :ripple="false"><v-icon small left>mdi-download</v-icon>Descargar archivo</v-btn>
              <template v-if="(instance.only_draft && ['pending', 'failed', 'finalized'].includes(instance.status)) || (!instance.only_draft && ['pending', 'failed'].includes(instance.status))">
                <v-btn @click="destroy" outlined color="red" retain-focus-on-click :ripple="false">Eliminar proceso</v-btn>
              </template>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0 background">
          <v-row class="px-4">
            <v-col cols="2">
              <span class="d-block mb-1">Facturas</span>
              <span class="body-1 font-weight-medium mr-1">{{count}}</span>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col cols="2" class="ml-2">
              <span class="d-block mb-1">Creado el</span>
              <span class="body-1 font-weight-medium mr-1">{{instance.created | date}}</span>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col cols="2" class="ml-2">
              <span class="d-block mb-1">Estado</span>
              <v-chip v-if="instance.status === 'pending'" color="defaultGrey" text-color="secondary" small>Pendiente</v-chip>
              <v-chip v-if="instance.status === 'processing'" class="caption" color="defaultGrey" text-color="secondary" small>Procesando</v-chip>
              <v-chip v-if="instance.status === 'finalized'" color="lightBlue" text-color="primary" small>Finalizado<v-icon x-small>mdi-check</v-icon></v-chip>
              <v-chip v-if="instance.status === 'failed'" class="caption" color="defaultGrey" text-color="secondary" small>Fallido<v-icon x-small>mdi-close</v-icon></v-chip>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col cols="4" class="ml-2">
              <div d-flex class="text-left d-flex">
                <v-icon small color="primary" v-if="instance.send_email">mdi-check</v-icon>
                <v-icon small color="red" v-else>mdi-close</v-icon>
                <span class="ml-1">Enviar email</span>
              </div>
              <div class="text-left d-flex mt-2">
                <v-icon small color="primary" v-if="instance.only_draft">mdi-check</v-icon>
                <v-icon small color="red" v-else>mdi-close</v-icon>
                <span class="ml-1">Generar solo borradores</span>
              </div>
            </v-col>
          </v-row>
          <v-divider />
          <invoice-list :has-link="false" :show-status="instance.status !== 'pending'" :show-create="true" :show-sort="false" :show-select-row="instance.status === 'pending'" :show-pagination="false" />
          <v-divider />
          <v-row class="mx-0" align="center">
            <v-col cols="6">
              <v-btn :to="{name: 'InvoiceList', query: {bulk: instance.id}}" outlined color="secondary">Ver todas las facturas</v-btn>
            </v-col>
            <v-col class="text-right" cols="6">
              <!-- <v-btn @click="finalize" outlined color="secondary">Aprobar selección</v-btn> -->
              <v-btn @click="finalize" v-if="instance.status === 'pending'" :loading="$store.state.bulks.createLoader" :disabled="$store.state.bulks.createLoader" outlined color="secondary">Aprobar todo</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-overlay :value="$store.state.bulks.createLoader" opacity="0.85" z-index="300">
      <div class="d-flex flex-column align-center text-center px-6">
        <v-progress-circular class="mb-4" size="56" width="5" color="primary" indeterminate />
        <span class="subtitle-1 font-weight-medium white--text">Estamos verificando y confirmando el proceso de facturación</span>
        <span class="body-2 mt-2 white--text">Este proceso puede demorar un par de minutos. No cierres ni recargues esta página.</span>
      </div>
    </v-overlay>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import InvoiceList from '@/components/invoice/InvoiceList'
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  mixins: [
    GenericViewMixin
  ],
  components: {
    InvoiceList,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  data: () => ({ }),
  created () {
    this.retrieve()
  },
  computed: mapState({
    count: state => state.invoices.invoicesCount,
    instance: state => state.bulks.invoicesDetail,
    invoicesList: state => state.invoices.invoicesList
  }),
  methods: {
    retrieve () {
      this.$store.dispatch('bulks/RETRIEVE', {
        resource: 'bulks/invoices',
        id: this.$route.params.id
      })
      .then(() => {
        this.$store.dispatch('invoices/LIST', {
          resource: 'invoices',
          query: {
            bulk: this.$route.params.id,
            page_size: 10
          }
        })
      })
    },
    destroy () {
      this.$dialog.warning({
        title: 'Eliminar proceso',
        text: `
          <span class="d-block my-2">¿Estás seguro de continuar?</span>
          <span class="d-block my-2 font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('bulks/DESTROY', {
                resource: 'bulks/invoices',
                id: this.$route.params.id
              })
              .then(() => {
                this.$router.push({ name: 'InvoiceBulkListCreate' })
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    finalize () {
      this.$dialog.warning({
        title: 'Crear facturación',
        text: `
          <span class="d-block mb-4">Al confirmar:</span>
          <span class="d-block pl-6">Se crearán ${this.instance.only_draft ? 'los borradores' : 'las facturas'}</span>
          <span class="d-block pl-6">${this.instance.send_email ? 'Se enviarán a cada cliente' : ''}</span>
          <span class="d-block font-weight-medium my-4">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'primary',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('bulks/CREATE', {
                resource: 'bulks/invoices',
                detail: 'finalize',
                id: this.$route.params.id,
                payload: {
                  invoices: 'all'
                }
              })
              .then(() => {
                if (this.instance.only_draft) {
                  this.$router.push({ name: 'InvoiceList', query: { bulk: this.instance.id } })
                } else {
                  this.$router.push({ name: 'InvoiceBulkListCreate', query: { status: 'processing' } })
                }
              })
              .catch((error) => {
                this.$dialog.message.error(error.response.data.non_field_errors || 'Error al confirmar la facturación.')
              })
            }
          }
        ]
      })
    }
  }
}
</script>
